<template>
  <CRow>
    <CCol sm="12">

      <CCard v-if="kunden">

        <CCardHeader>
          <CRow>
            <CCol sm="8">
              <CIcon name="cil-window"/>
              <h5>Übersicht über alle Kunden</h5>
            </CCol>
            <CCol sm="4" class="text-right">
              <CButton color="success" size="sm" v-on:click="newEntry"><CIcon name="cil-library-add"/> Neuer Kunde</CButton>
            </CCol>
          </CRow>
        </CCardHeader>

        <CCardBody>
          <CRow>
            <CCol sm="12">

              <CTabs>
                <CTab add-tab-classes="mt-1">
                  <template slot="title">
                    <CIcon name="cil-thumb-up"/>
                    <span>Aktiv</span>
                  </template>
                  <Table :kunden="aktiv" v-model="reload"/>
                </CTab>
                <CTab add-tab-classes="mt-1">
                  <template slot="title">
                    <CIcon name="cil-thumb-down"/>
                    <span>Inaktiv</span>
                  </template>
                  <Table :kunden="inaktiv" v-model="reload"/>
                </CTab>
              </CTabs>
            </CCol>
          </CRow>
        </CCardBody>

      </CCard>

    </CCol>
  </CRow>
</template>

<script>
import Vue from 'vue'
import Table from '@/views/Kunden/Table'

export default {
  name: 'MitarbeiterIndex',
  components: {
    Table
  },
  data () {
    return {
      kunden: '-',
      reload: ''
    }
  },
  computed: {
    aktiv () {
      if (this.kunden) {
        return this._.filter(this.kunden, function (kd) {
          return kd.aktiv
        })
      } else {
        return null
      }
    },
    inaktiv () {
      if (this.kunden) {
        return this._.filter(this.kunden, function (kd) {
          return !kd.aktiv
        })
      } else {
        return null
      }
    }
  },
  mounted () {
    this.loadKunden()
  },
  watch: {
    reload: function () {
      if (this.reload) {
        this.loadKunden()
        this.reload = ''
      }
    }
  },
  methods: {
    newEntry () {
      this.$router.push({ path: '/kunden/neu' })
    },
    loadKunden () {
      Vue.axios.get('/kunden/get')
        .then((response) => {
          this.kunden = response.data
        })
    }
  }
}
</script>
